import { render, staticRenderFns } from "./CadastroConsulta.vue?vue&type=template&id=3886e2b4&scoped=true&"
import script from "./CadastroConsulta.vue?vue&type=script&lang=js&"
export * from "./CadastroConsulta.vue?vue&type=script&lang=js&"
import style0 from "./CadastroConsulta.vue?vue&type=style&index=0&id=3886e2b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3886e2b4",
  null
  
)

export default component.exports